import { render } from "./SlackLogoIcon.vue?vue&type=template&id=2e9fd3c6"
import script from "./SlackLogoIcon.vue?vue&type=script&lang=js"
export * from "./SlackLogoIcon.vue?vue&type=script&lang=js"

import "./SlackLogoIcon.vue?vue&type=style&index=0&id=2e9fd3c6&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__